interface TableOfContentsProps {
  summary_title: string;
  items: {
    id: string;
    title: string;
  }[];
}

const TableOfContents: React.FC<TableOfContentsProps> = ({
  summary_title,
  items,
}) => {
  return (
    <div className="summary">
      <h2>{summary_title}</h2>
      <ol>
        {items.map((item) => (
          <li key={item.id}>
            <a href={`#${item.id}`}>{item.title}</a>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default TableOfContents;
